module.exports = __webpack_public_path__ + "img/logo_desk_vet_crooped.39b45cff.png";